import { render } from "./Me.vue?vue&type=template&id=6b8fcbe2"
import script from "./Me.vue?vue&type=script&lang=js"
export * from "./Me.vue?vue&type=script&lang=js"

import "./Me.vue?vue&type=style&index=0&id=6b8fcbe2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__